/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiCommonDashboardGetContractNumberGet } from '../fn/dashboard/api-common-dashboard-get-contract-number-get';
import { ApiCommonDashboardGetContractNumberGet$Params } from '../fn/dashboard/api-common-dashboard-get-contract-number-get';
import { apiCommonDashboardGetContractNumberGet$Plain } from '../fn/dashboard/api-common-dashboard-get-contract-number-get-plain';
import { ApiCommonDashboardGetContractNumberGet$Plain$Params } from '../fn/dashboard/api-common-dashboard-get-contract-number-get-plain';
import { apiCommonDashboardGetDashboardDataPost } from '../fn/dashboard/api-common-dashboard-get-dashboard-data-post';
import { ApiCommonDashboardGetDashboardDataPost$Params } from '../fn/dashboard/api-common-dashboard-get-dashboard-data-post';
import { apiCommonDashboardGetDashboardDataPost$Plain } from '../fn/dashboard/api-common-dashboard-get-dashboard-data-post-plain';
import { ApiCommonDashboardGetDashboardDataPost$Plain$Params } from '../fn/dashboard/api-common-dashboard-get-dashboard-data-post-plain';
import { apiCommonDashboardGetFilteredDashboardPost } from '../fn/dashboard/api-common-dashboard-get-filtered-dashboard-post';
import { ApiCommonDashboardGetFilteredDashboardPost$Params } from '../fn/dashboard/api-common-dashboard-get-filtered-dashboard-post';
import { apiCommonDashboardGetFilteredDashboardPost$Plain } from '../fn/dashboard/api-common-dashboard-get-filtered-dashboard-post-plain';
import { ApiCommonDashboardGetFilteredDashboardPost$Plain$Params } from '../fn/dashboard/api-common-dashboard-get-filtered-dashboard-post-plain';
import { apiCommonDashboardGetLastDashboardPost } from '../fn/dashboard/api-common-dashboard-get-last-dashboard-post';
import { ApiCommonDashboardGetLastDashboardPost$Params } from '../fn/dashboard/api-common-dashboard-get-last-dashboard-post';
import { apiCommonDashboardGetLastDashboardPost$Plain } from '../fn/dashboard/api-common-dashboard-get-last-dashboard-post-plain';
import { ApiCommonDashboardGetLastDashboardPost$Plain$Params } from '../fn/dashboard/api-common-dashboard-get-last-dashboard-post-plain';
import { apiCommonDashboardGetStagesChartDataPost } from '../fn/dashboard/api-common-dashboard-get-stages-chart-data-post';
import { ApiCommonDashboardGetStagesChartDataPost$Params } from '../fn/dashboard/api-common-dashboard-get-stages-chart-data-post';
import { apiCommonDashboardGetStagesChartDataPost$Plain } from '../fn/dashboard/api-common-dashboard-get-stages-chart-data-post-plain';
import { ApiCommonDashboardGetStagesChartDataPost$Plain$Params } from '../fn/dashboard/api-common-dashboard-get-stages-chart-data-post-plain';
import { apiCommonDashboardGetUsersPost } from '../fn/dashboard/api-common-dashboard-get-users-post';
import { ApiCommonDashboardGetUsersPost$Params } from '../fn/dashboard/api-common-dashboard-get-users-post';
import { apiCommonDashboardGetUsersPost$Plain } from '../fn/dashboard/api-common-dashboard-get-users-post-plain';
import { ApiCommonDashboardGetUsersPost$Plain$Params } from '../fn/dashboard/api-common-dashboard-get-users-post-plain';
import { GetContractorNumberQueryResult } from '../models/get-contractor-number-query-result';
import { GetDashboardQueryResult } from '../models/get-dashboard-query-result';
import { GetFilteredDashboardQueryResult } from '../models/get-filtered-dashboard-query-result';
import { GetLastDashboardQueryResult } from '../models/get-last-dashboard-query-result';
import { GetStagesChartQueryResult } from '../models/get-stages-chart-query-result';
import { GetUsersByRoleQueryResult } from '../models/get-users-by-role-query-result';

@Injectable({ providedIn: 'root' })
export class DashboardService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiCommonDashboardGetDashboardDataPost()` */
  static readonly ApiCommonDashboardGetDashboardDataPostPath = '/api/Common/Dashboard/GetDashboardData';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCommonDashboardGetDashboardDataPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonDashboardGetDashboardDataPost$Plain$Response(params?: ApiCommonDashboardGetDashboardDataPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetDashboardQueryResult>> {
    return apiCommonDashboardGetDashboardDataPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCommonDashboardGetDashboardDataPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonDashboardGetDashboardDataPost$Plain(params?: ApiCommonDashboardGetDashboardDataPost$Plain$Params, context?: HttpContext): Observable<GetDashboardQueryResult> {
    return this.apiCommonDashboardGetDashboardDataPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetDashboardQueryResult>): GetDashboardQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCommonDashboardGetDashboardDataPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonDashboardGetDashboardDataPost$Response(params?: ApiCommonDashboardGetDashboardDataPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetDashboardQueryResult>> {
    return apiCommonDashboardGetDashboardDataPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCommonDashboardGetDashboardDataPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonDashboardGetDashboardDataPost(params?: ApiCommonDashboardGetDashboardDataPost$Params, context?: HttpContext): Observable<GetDashboardQueryResult> {
    return this.apiCommonDashboardGetDashboardDataPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetDashboardQueryResult>): GetDashboardQueryResult => r.body)
    );
  }

  /** Path part for operation `apiCommonDashboardGetFilteredDashboardPost()` */
  static readonly ApiCommonDashboardGetFilteredDashboardPostPath = '/api/Common/Dashboard/GetFilteredDashboard';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCommonDashboardGetFilteredDashboardPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonDashboardGetFilteredDashboardPost$Plain$Response(params?: ApiCommonDashboardGetFilteredDashboardPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetFilteredDashboardQueryResult>> {
    return apiCommonDashboardGetFilteredDashboardPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCommonDashboardGetFilteredDashboardPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonDashboardGetFilteredDashboardPost$Plain(params?: ApiCommonDashboardGetFilteredDashboardPost$Plain$Params, context?: HttpContext): Observable<GetFilteredDashboardQueryResult> {
    return this.apiCommonDashboardGetFilteredDashboardPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetFilteredDashboardQueryResult>): GetFilteredDashboardQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCommonDashboardGetFilteredDashboardPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonDashboardGetFilteredDashboardPost$Response(params?: ApiCommonDashboardGetFilteredDashboardPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetFilteredDashboardQueryResult>> {
    return apiCommonDashboardGetFilteredDashboardPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCommonDashboardGetFilteredDashboardPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonDashboardGetFilteredDashboardPost(params?: ApiCommonDashboardGetFilteredDashboardPost$Params, context?: HttpContext): Observable<GetFilteredDashboardQueryResult> {
    return this.apiCommonDashboardGetFilteredDashboardPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetFilteredDashboardQueryResult>): GetFilteredDashboardQueryResult => r.body)
    );
  }

  /** Path part for operation `apiCommonDashboardGetLastDashboardPost()` */
  static readonly ApiCommonDashboardGetLastDashboardPostPath = '/api/Common/Dashboard/GetLastDashboard';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCommonDashboardGetLastDashboardPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonDashboardGetLastDashboardPost$Plain$Response(params?: ApiCommonDashboardGetLastDashboardPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetLastDashboardQueryResult>> {
    return apiCommonDashboardGetLastDashboardPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCommonDashboardGetLastDashboardPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonDashboardGetLastDashboardPost$Plain(params?: ApiCommonDashboardGetLastDashboardPost$Plain$Params, context?: HttpContext): Observable<GetLastDashboardQueryResult> {
    return this.apiCommonDashboardGetLastDashboardPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetLastDashboardQueryResult>): GetLastDashboardQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCommonDashboardGetLastDashboardPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonDashboardGetLastDashboardPost$Response(params?: ApiCommonDashboardGetLastDashboardPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetLastDashboardQueryResult>> {
    return apiCommonDashboardGetLastDashboardPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCommonDashboardGetLastDashboardPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonDashboardGetLastDashboardPost(params?: ApiCommonDashboardGetLastDashboardPost$Params, context?: HttpContext): Observable<GetLastDashboardQueryResult> {
    return this.apiCommonDashboardGetLastDashboardPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetLastDashboardQueryResult>): GetLastDashboardQueryResult => r.body)
    );
  }

  /** Path part for operation `apiCommonDashboardGetUsersPost()` */
  static readonly ApiCommonDashboardGetUsersPostPath = '/api/Common/Dashboard/GetUsers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCommonDashboardGetUsersPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCommonDashboardGetUsersPost$Plain$Response(params?: ApiCommonDashboardGetUsersPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUsersByRoleQueryResult>> {
    return apiCommonDashboardGetUsersPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCommonDashboardGetUsersPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCommonDashboardGetUsersPost$Plain(params?: ApiCommonDashboardGetUsersPost$Plain$Params, context?: HttpContext): Observable<GetUsersByRoleQueryResult> {
    return this.apiCommonDashboardGetUsersPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetUsersByRoleQueryResult>): GetUsersByRoleQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCommonDashboardGetUsersPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCommonDashboardGetUsersPost$Response(params?: ApiCommonDashboardGetUsersPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUsersByRoleQueryResult>> {
    return apiCommonDashboardGetUsersPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCommonDashboardGetUsersPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCommonDashboardGetUsersPost(params?: ApiCommonDashboardGetUsersPost$Params, context?: HttpContext): Observable<GetUsersByRoleQueryResult> {
    return this.apiCommonDashboardGetUsersPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetUsersByRoleQueryResult>): GetUsersByRoleQueryResult => r.body)
    );
  }

  /** Path part for operation `apiCommonDashboardGetStagesChartDataPost()` */
  static readonly ApiCommonDashboardGetStagesChartDataPostPath = '/api/Common/Dashboard/GetStagesChartData';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCommonDashboardGetStagesChartDataPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonDashboardGetStagesChartDataPost$Plain$Response(params?: ApiCommonDashboardGetStagesChartDataPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetStagesChartQueryResult>> {
    return apiCommonDashboardGetStagesChartDataPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCommonDashboardGetStagesChartDataPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonDashboardGetStagesChartDataPost$Plain(params?: ApiCommonDashboardGetStagesChartDataPost$Plain$Params, context?: HttpContext): Observable<GetStagesChartQueryResult> {
    return this.apiCommonDashboardGetStagesChartDataPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetStagesChartQueryResult>): GetStagesChartQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCommonDashboardGetStagesChartDataPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonDashboardGetStagesChartDataPost$Response(params?: ApiCommonDashboardGetStagesChartDataPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetStagesChartQueryResult>> {
    return apiCommonDashboardGetStagesChartDataPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCommonDashboardGetStagesChartDataPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCommonDashboardGetStagesChartDataPost(params?: ApiCommonDashboardGetStagesChartDataPost$Params, context?: HttpContext): Observable<GetStagesChartQueryResult> {
    return this.apiCommonDashboardGetStagesChartDataPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetStagesChartQueryResult>): GetStagesChartQueryResult => r.body)
    );
  }

  /** Path part for operation `apiCommonDashboardGetContractNumberGet()` */
  static readonly ApiCommonDashboardGetContractNumberGetPath = '/api/Common/Dashboard/GetContractNumber';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCommonDashboardGetContractNumberGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCommonDashboardGetContractNumberGet$Plain$Response(params?: ApiCommonDashboardGetContractNumberGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetContractorNumberQueryResult>> {
    return apiCommonDashboardGetContractNumberGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCommonDashboardGetContractNumberGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCommonDashboardGetContractNumberGet$Plain(params?: ApiCommonDashboardGetContractNumberGet$Plain$Params, context?: HttpContext): Observable<GetContractorNumberQueryResult> {
    return this.apiCommonDashboardGetContractNumberGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetContractorNumberQueryResult>): GetContractorNumberQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCommonDashboardGetContractNumberGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCommonDashboardGetContractNumberGet$Response(params?: ApiCommonDashboardGetContractNumberGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetContractorNumberQueryResult>> {
    return apiCommonDashboardGetContractNumberGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCommonDashboardGetContractNumberGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCommonDashboardGetContractNumberGet(params?: ApiCommonDashboardGetContractNumberGet$Params, context?: HttpContext): Observable<GetContractorNumberQueryResult> {
    return this.apiCommonDashboardGetContractNumberGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetContractorNumberQueryResult>): GetContractorNumberQueryResult => r.body)
    );
  }

}
